import React from "react";
import "./pagination.css";

export default function Pagination({ currentPage, totalPages, setCurrentPage, postsPerPage, totalArticles, label = "articles" }) {
  const delta = 2;
  const getPageNumbers = () => {
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) rangeWithDots.push(l + 1);
        else if (i - l !== 1) rangeWithDots.push("...");
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <>
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
        >
          Prev
        </button>

        {pageNumbers.map((number, index) =>
          number === "..." ? (
            <span key={index}>...</span>
          ) : (
            <button
              key={index}
              onClick={() => {
                setCurrentPage(number);
                window.scroll(0, 0);
              }}
              className={number === currentPage ? "active" : ""}
            >
              {number}
            </button>
          )
        )}

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ padding: "6px 12px", borderRadius: "8px", backgroundColor: "#B1E5F2", border: "none", cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
        >
          Next
        </button>
      </div>
      <div className="page-indicator">
        Page {currentPage} of {totalPages}
      </div>
      <div className="article-range">
        Showing {(currentPage - 1) * postsPerPage + 1} – {Math.min(currentPage * postsPerPage, totalArticles)} of {totalArticles} {label.charAt(0).toUpperCase() + label.slice(1)}
      </div>
    </>
  );
}
